import script from "./TherapistsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TherapistsPage.vue?vue&type=script&setup=true&lang=js"

import "./TherapistsPage.vue?vue&type=style&index=0&id=34cac2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cac2ca"]])

export default __exports__